import { font, TransparentButton } from '@approvalmax/ui';
import { PlusIcon } from 'modules/sprites';
import styled from 'styled-components';

export const TransparentButtonStyled = styled(TransparentButton)`
    margin: 0 60px;
    height: 50px;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    border-top: none;
    ${font(13, '#518d60', 'semibold')}
    fill: currentColor;

    &:hover {
        border-color: #cacccd;
        color: #2a5844;
    }
`;

export const AddLineIcon = styled(PlusIcon)`
    margin-left: 20px;
    margin-right: 34px;
`;
